import type { FaireProductEntity } from "../../entity_types/product";

export const p_cxsva7huwh: FaireProductEntity = {
  token: "p_cxsva7huwh",
  type: "product",
  name: "Blue Gingham Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b26537a549e5e7844ceb7513e2f6c7b935bcf1d8565c0e026d30c38553c817ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e56ee4dc68b4c77ede15c1621b81813fb268211b51e42d3111e7694d800f387d.jpeg",
    "https://cdn.faire.com/fastly/92eb2228de2fd1a1f2a41c79caa194c82ddf8f36d990c4391074f9aa1cd0f23a.jpeg",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:43.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
